module.exports = __webpack_public_path__ + "static/p04_comida-71601c8d655ceef54e4267137d899b4c.png";